/**
 * Central API base URL getters — resolve auth (Wix / CRE / R4V) then pick microservice URLs.
 */
import { AUTH_SOURCE, authSourceFromSystemCode } from "../constants/authSource";
import { useGlobalStore } from "../context/UserContext/userContext";
import { getApiBaseUrlsForAuth } from "./apiBaseUrlsConstants";

/**
 * Resolve auth channel for API base URLs (stable during app startup).
 *
 * Prefer store.authSource, then wixToken/isWixAuth, then URL systemCode.
 * Wix embeds must include systemCode=WIX (added after login, same as CRE).
 */
function resolveAuthSourceForBaseUrls() {
  const store = useGlobalStore.getState();

  if (store?.authSource) {
    return store.authSource;
  }

  // { fallback sources for auth source }
  if (store?.wixToken || store?.isWixAuth) {
    return AUTH_SOURCE.WIX;
  }

  if (typeof window !== "undefined") {
    const fromSystemCode = authSourceFromSystemCode(
      new URLSearchParams(window.location.search || "").get("systemCode"),
    );
    if (fromSystemCode) {
      return fromSystemCode;
    }
  }

  return AUTH_SOURCE.RADICAL;
}

function getApiBaseUrlsForCurrentAuth() {
  return getApiBaseUrlsForAuth(resolveAuthSourceForBaseUrls());
}

export function getReportingApiBaseUrl() {
  return getApiBaseUrlsForCurrentAuth().reporting;
}

export function getStudyApiBaseUrl() {
  return getApiBaseUrlsForCurrentAuth().study;
}
